import React, { memo } from "react";
import isEqual from "lodash/isEqual";
import { Flex, Span, StarRating } from "@catchoftheday/cg-components";
import { SEARCH_FACET_DISPLAY_TYPE_RATING } from "@search-app/helpers/search/search.helpers.facets";
import { FacetListItem } from "../../SearchFacets.styles";
import { SearchFacetsCheckbox } from "../SearchFacetsCheckbox";
import { jsx as ___EmotionJSX } from "@emotion/react";

var SearchFacetsListItemComponent = function SearchFacetsListItemComponent(_ref) {
  var checked = _ref.checked,
      count = _ref.count,
      display = _ref.display,
      id = _ref.id,
      _ref$isRadio = _ref.isRadio,
      isRadio = _ref$isRadio === void 0 ? false : _ref$isRadio,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value,
      columns = _ref.columns,
      focused = _ref.focused,
      isSortBy = _ref.isSortBy,
      padding = _ref.padding;
  var displayType = display === null || display === void 0 ? void 0 : display.type;
  var displayProps = display === null || display === void 0 ? void 0 : display.props;
  var displayLabel = displayType && displayProps && displayType === SEARCH_FACET_DISPLAY_TYPE_RATING ? ___EmotionJSX(Flex, null, ___EmotionJSX(StarRating, {
    rating: displayProps.value,
    starColour: displayProps.color,
    width: 95
  }), displayProps.value < 5 ? ___EmotionJSX(Span, {
    ml: "5px"
  }, "& up") : "") : label;
  return ___EmotionJSX(FacetListItem, {
    isSortBy: isSortBy,
    padding: padding,
    columns: columns
  }, ___EmotionJSX(SearchFacetsCheckbox, {
    count: count,
    description: displayLabel,
    id: id,
    checked: checked,
    isRadio: isRadio,
    name: name,
    onChange: onChange,
    value: value,
    focused: focused
  }));
};

export var SearchFacetsListItem = /*#__PURE__*/memo(SearchFacetsListItemComponent, function (prevProps, nextProps) {
  // Deep equality check as value is seen as new object on each render
  return isEqual(prevProps, nextProps);
});